import React, { FC } from 'react';
import { SystemManager } from '../../../utils/SystemManager';

const TitularOro: FC = () => {
  return <>{SystemManager.getSystem('tarjeta-titular-oro')}</>;
};

export default TitularOro;
